import { Response } from '@/types/IData'
import { message } from 'antd';

export const isFunction = (obj: any) => typeof obj === "function" && typeof obj.nodeType !== "number";
export const hasChina = (str: string) => /.*[\u4e00-\u9fa5]+.*$/.test(str);
export const isNullObject = (obj: object) => JSON.stringify(obj) === "{}";
// 📱 手机号
export const checkPhone = (phone: string) => /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,1,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(phone);
export const isEmail = (str: string) => /^[a-zA-Z0-9][a-zA-Z0-9._-]*\@[a-zA-Z0-9]{1,10}\.[a-zA-Z0-9\.]{1,20}$/.test(str);
export const isIosOrAndroid = function () {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    let isStr = ''
    if (isAndroid) {
        isStr = 'android'
    }
    if (isiOS) {
        isStr = 'ios'
    }
    return isStr
}
export const checkResultError = (res: Response, showMsg: boolean = true) => {
    if (res.code !== 200) {
        if (showMsg) message.error(res.message);
        return true;
    }
}
